import { customElement, property } from "lit/decorators.js";
import { html, LitElement, nothing } from "lit";
import { consume } from "@lit/context";
import { filterContext, IFilterContext } from "../ehm-filter/filterContext";

@customElement("ehm-pagination")
export class Filter extends LitElement {

  @property()
  for: string = "";
  @property()
  param: string = "p";
  @consume({ context: filterContext, subscribe: true })
  context?: IFilterContext;

  connectedCallback() {
    super.connectedCallback();
    const paginationForElement = document.getElementById(this.for);
    if (!paginationForElement) return;
    this.querySelectorAll("a").forEach(a => {
      a.addEventListener("click", (e) => {
        e.preventDefault();
        const url = new URL(a.href);
        const searchParams = new URLSearchParams(url.search);
        const page = searchParams.get(this.param);
        this.dispatchEvent(new CustomEvent("pagination-changed", { detail: { page }, bubbles: true, composed: true }));
      });
    });
  }

  render() {
    if (this.context && this.context?.total < this.context?.pageSize) return nothing;
    return html`
      <slot></slot>
    `;
  }
}
